if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends HTMLElement {
      connectedCallback() {
        this.acceptButton = this.querySelector('[data-cookie-accept]');
        this.declineButton = this.querySelector('[data-cookie-decline]');

        if (this.acceptButton) this.acceptButton.addEventListener('click', () => this.respond(true));
        if (this.declineButton) this.declineButton.addEventListener('click', () => this.respond(false));

        document.addEventListener('visitorConsentCollected', () => this.hide());

        this.init();
      }

      init() {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) return;
          this.privacy = window.Shopify.customerPrivacy;
          if (!this.privacy) return;

          if (!this.privacy.shouldShowBanner()) return;

          const consent = this.privacy.currentVisitorConsent();
          const alreadyDeclared = Object.values(consent).some((value) => value !== '');
          if (alreadyDeclared) return;

          this.show();
        });
      }

      show() {
        this.hidden = false;
      }

      hide() {
        this.hidden = true;
      }

      respond(granted) {
        if (!this.privacy) {
          this.hide();
          return;
        }

        [this.acceptButton, this.declineButton].forEach((button) => {
          if (button) button.setAttribute('aria-disabled', 'true');
        });

        this.privacy.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted,
          },
          () => this.hide()
        );
      }
    }
  );
}
